import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./Login.css";

function ifObjectIsEmpty(object){
   var isEmpty=true;
   if(JSON.stringify(object)===JSON.stringify({})){
     isEmpty = true;
   }
   else{
     isEmpty = false;
   }
   return isEmpty;
}

async function loginUser(username, password) {
  return fetch('https://komercijala.pakom.hr/auth.php?username='+username+'&password='+password)
  .then(data => data.json())
 }

const Login = ( props ) => {

  // izbriši sve lokalno pohranjene partnere i cjenike
  localStorage.clear();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async e => {
      e.preventDefault();

      const token = await loginUser(
        username,
        password
      );

      if (ifObjectIsEmpty(token)) {
        alert("Neispravna šifra!");
          }
      else {
        props.setToken(token);
      }
    }

  function validateForm() {
    return username.length > 0 && password.length > 0;
  }

  return (
    <div className="Login">
      <Form onSubmit={handleSubmit}>
        <div className="m-5">
        <Form.Group size="lg" controlId="username">
          <Form.Label>Korisničko ime</Form.Label>
          <Form.Control
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Group>

        <p> </p>

        <Form.Group controlId="password">
          <Form.Label>Lozinka</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>

        <p> </p>

        <Button size="lg" type="submit" disabled={!validateForm()}>
          Prijava
        </Button>
        </div>

      </Form>
    </div>
  );
}

export default Login
